import { cookiesToZUID, cookiesToZGUID } from "@zillow/mortgage-urls";
import { useState, useEffect } from "react";
function usePopulateParamPlaceHolders(stringWithParamPlaceholders) {
  const [populatedParams, setPopulatedParams] = useState(stringWithParamPlaceholders);
  useEffect(function populateParamsOnMountToAvoidHydrationError() {
    if (!stringWithParamPlaceholders) {
      return;
    }
    setPopulatedParams(populateParamPlaceholders(stringWithParamPlaceholders));
  }, [stringWithParamPlaceholders]);
  return populatedParams;
}
function populateParamPlaceholders(inputString) {
  if (!inputString) {
    return inputString;
  }
  if (typeof window === "undefined") {
    return inputString;
  }
  if (typeof inputString !== "string") {
    return inputString;
  }
  let inputSearchParams;
  try {
    inputSearchParams = new URL(inputString, window.location.origin).searchParams;
  } catch (error) {
    console.error("Error creating URL object from inputString", error);
    return inputString;
  }
  const originalInputSearchString = "?" + inputSearchParams.toString();
  const currentPageParams = new URL(window.location.href, window.location.origin).searchParams;
  currentPageParams.set("zuid", ifNullStringNull(cookiesToZUID(document.cookie)) || "");
  currentPageParams.set("guid", ifNullStringNull(cookiesToZGUID(document.cookie)) || "");
  for (const [maybePlaceholderParam, maybePlaceholderParamValue] of Array.from(inputSearchParams.entries())) {
    const isPlaceholderParam = maybePlaceholderParamValue === "";
    if (isPlaceholderParam && currentPageParams.has(maybePlaceholderParam)) {
      const currentPageValues = currentPageParams.getAll(maybePlaceholderParam);
      inputSearchParams.delete(maybePlaceholderParam);
      for (const value of currentPageValues) {
        if (!value.trim()) {
          continue;
        }
        inputSearchParams.append(maybePlaceholderParam, value);
      }
    }
  }
  Array.from(inputSearchParams.keys()).forEach((key) => {
    if (inputSearchParams.get(key) === "") {
      inputSearchParams.delete(key);
    }
  });
  const populatedInputSearchString = inputSearchParams.toString() === "" ? "" : "?" + inputSearchParams.toString();
  const result = inputString.replace(originalInputSearchString, populatedInputSearchString);
  return result;
}
function ifNullStringNull(value) {
  if (value === "null") {
    return null;
  }
  return value;
}
export {
  populateParamPlaceholders,
  usePopulateParamPlaceHolders
};
